<div [formGroup]="formArray.controls[group]" class="market-app-list">
    <targeting-container label="APP LIST" (onEdit)="openSidebar()" [hideRemove]="true" [disabled]="isDisabled">
        <span *ngIf="tooltipTextForInclude.length || tooltipTextForExclude.length">
            <span class="font-weight-bold mr-2">App Lists:&nbsp;</span>
            <span class="hide-chip-close-button" *ngIf="tooltipTextForInclude.length">
                <acl-ngx-tooltip [trigger]="trigger" [disabled]="!tooltipTextForInclude.length"
                    [text]="tooltipTextForInclude.join(', ')">
                </acl-ngx-tooltip>
                <ng-template #trigger>
                    <acl-ngx-chip (click)="openSidebar()"
                        [text]="tooltipTextForInclude.length === 1 ? includeListCount : '(' + includeListCount + ')'">
                    </acl-ngx-chip>
                </ng-template>
            </span>
            <span class="exclude margin-left-5 hide-chip-close-button" *ngIf="tooltipTextForExclude.length">
                <acl-ngx-tooltip [trigger]="trigger" [disabled]="!tooltipTextForExclude.length"
                    [text]="tooltipTextForExclude.join(', ')">
                </acl-ngx-tooltip>
                <ng-template #trigger>
                    <acl-ngx-chip (click)="openSidebar()"
                        [text]="tooltipTextForExclude.length === 1 ? excludeListCount : '(' + excludeListCount + ')'">
                    </acl-ngx-chip>
                </ng-template>
            </span>
        </span>
        <span *ngIf="!tooltipTextForInclude.length && !tooltipTextForExclude.length"
            class="font-italic py-1 font-weight-normal">
            <span (click)="openSidebar()" [ngClass]="isDisabled ? 'disabled' : 'cursor-pointer'">Select</span>
        </span>
    </targeting-container>
    <acl-ngx-flyout [open]="open" (close)="cancel()" large="true" portalRoot="market-app-list">
        <acl-ngx-flyout-header title="App List" (close)="cancel()">
        </acl-ngx-flyout-header>
        <acl-ngx-flyout-body>
            <browse-include-exclude [(dataConfig)]="dataConfig" [settings]="settings" [hidden]="!open">
            </browse-include-exclude>
        </acl-ngx-flyout-body>
        <acl-ngx-flyout-footer [leftButton]="saveButton" [rightButton]="cancelButton">
        </acl-ngx-flyout-footer>
    </acl-ngx-flyout>
</div>